module.exports = {
  "zones": {
    "Europe/Budapest": ["z", {
      "wallclock": 338958000000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": 338950800000,
      "save": 0,
      "rules": "EU"
    }, {
      "wallclock": -788918400000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -788922000000,
      "save": 0,
      "rules": "Hungary"
    }, {
      "wallclock": -906768000000,
      "format": "CE%sT",
      "abbrev": "CEST",
      "offset": 3600000,
      "posix": -906771600000,
      "save": 3600000,
      "rules": "C-Eur"
    }, {
      "wallclock": -1640995200000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -1640998800000,
      "save": 0,
      "rules": "Hungary"
    }, {
      "wallclock": -2500934400000,
      "format": "CE%sT",
      "abbrev": "CET",
      "offset": 3600000,
      "posix": -2500938980000,
      "save": 0,
      "rules": "C-Eur"
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 4580000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "EU": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1985,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1984,
      "to": 1984,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1982,
      "to": 1983,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1981,
      "to": 1981,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 60,
      "clock": "posix",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1979,
      "to": 1980,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 60,
      "clock": "posix",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "Hungary": [{
      "from": 1980,
      "to": 1980,
      "month": 3,
      "day": [7, 6],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1957,
      "month": 5,
      "day": [0, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1957,
      "to": 1957,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1956,
      "to": 1956,
      "month": 5,
      "day": [0, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1956,
      "to": 1956,
      "month": 8,
      "day": [0, -30],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1954,
      "to": 1955,
      "month": 4,
      "day": [7, 23],
      "time": 0,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1954,
      "to": 1955,
      "month": 9,
      "day": [7, 3],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1950,
      "to": 1950,
      "month": 3,
      "day": [7, 17],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1950,
      "to": 1950,
      "month": 9,
      "day": [7, 23],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1946,
      "to": 1949,
      "month": 9,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1947,
      "to": 1949,
      "month": 3,
      "day": [0, 4],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1946,
      "to": 1946,
      "month": 2,
      "day": [7, 31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 4,
      "day": [7, 1],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 10,
      "day": [7, 1],
      "time": 0,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1919,
      "to": 1919,
      "month": 3,
      "day": [7, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1919,
      "to": 1919,
      "month": 10,
      "day": [7, 24],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1918,
      "to": 1918,
      "month": 3,
      "day": [7, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1918,
      "month": 8,
      "day": [7, 16],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }],
    "C-Eur": [{
      "from": 1981,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1996,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1979,
      "to": 1995,
      "month": 8,
      "day": [0, -30],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1977,
      "to": 1980,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "standard",
      "save": 60,
      "letter": "S"
    }, {
      "from": 1978,
      "to": 1978,
      "month": 9,
      "day": [7, 1],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1977,
      "to": 1977,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1945,
      "month": 3,
      "day": [1, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [7, 16],
      "time": 120,
      "clock": "standard",
      "save": 0,
      "letter": ""
    }, {
      "from": 1944,
      "to": 1944,
      "month": 9,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 4],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 10,
      "day": [7, 2],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1940,
      "to": 1940,
      "month": 3,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 3,
      "day": [1, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1918,
      "month": 8,
      "day": [1, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }, {
      "from": 1916,
      "to": 1916,
      "month": 3,
      "day": [7, 30],
      "time": 1380,
      "clock": "wallclock",
      "save": 60,
      "letter": "S",
      "saved": 0
    }, {
      "from": 1916,
      "to": 1916,
      "month": 9,
      "day": [7, 1],
      "time": 60,
      "clock": "wallclock",
      "save": 0,
      "letter": "",
      "saved": 3600000
    }]
  }
};